import Row from '@amzn/meridian/row'
import React, { FC } from 'react'
import { ISheetProps, Sheet } from './Sheet'
import MeridianText from '@amzn/meridian/text'
import Button from '@amzn/meridian/button'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'

export interface IExitSheetProps extends ISheetProps {
    /**
     * The action for clicking the primary button
     *
     * @type {React.MouseEventHandler<HTMLButtonElement>}
     */
    onClickPrimary: React.MouseEventHandler<HTMLButtonElement>
}

/**
 * This component is used when an exit flow gets triggered during a task.
 */
export const ExitSheet: FC<IExitSheetProps> = (props: IExitSheetProps) => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
        <Sheet id={props.id} open={props.open} setSheetOpen={props.setSheetOpen} spacingInset="400">
            <Row alignmentHorizontal="center">
                <div>
                    <img alt={t(bundle, 'jsma-web-common-connectionsLogoAlt')} src={'./images/notifications_badge.svg'} />
                </div>
            </Row>
            <Row spacingInset="200 0" alignmentHorizontal="center">
                <MeridianText type="h400" >
                    {t(bundle, 'jsma-web-exit-confirmTitle')}
                </MeridianText>
            </Row>
            <Row spacingInset="200 0" alignmentHorizontal="center">
                <MeridianText type="h100" >
                    {t(bundle, 'jsma-web-exit-confirmMessage')}
                </MeridianText>
            </Row>
            <Row width="100%" widths="fill" spacingInset="200 0">
                <Button
                    type="primary"
                    size="medium"
                    onClick={props.onClickPrimary}
                >
                    {t(bundle, 'jsma-web-exit-exitButton')}
                </Button>
            </Row>
        </Sheet>
    )
}
